<template>
  <v-card
    class="mx-auto"
    style="box-shadow: none !important; background-color: #fff0 !important;"
  >
    <v-card-text class="qam-calc-box">
      <v-row>
        <v-col cols="12" sm="3">
          <h5>{{ value.ComparisonTile3 }}</h5>
        </v-col>
        <v-col cols="12" sm="3">
          <v-btn
            id="sort-offers--qam"
            v-bind:color="isAQ ? '#4aa54a' : '#3f677b'"
            block
            dark
            @click="bqb"
          >
            {{ value.ComparisonTile4 }}
          </v-btn>
        </v-col>
        <v-col cols="12" sm="3">
          <v-btn
            id="sort-offers--speed"
            v-bind:color="isAS ? '#4aa54a' : '#3f677b'"
            block
            dark
            @click="btf"
          >
            {{ value.ComparisonTile5 }}
          </v-btn>
        </v-col>
        <v-col cols="12" sm="3">
          <v-btn
            id="sort-offers--amt"
            v-bind:color="isAM ? '#4aa54a' : '#3f677b'"
            block
            dark
            @click="bvf"
          >
            {{ value.ComparisonTile6 }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-list two-line style="background-color: #fff0 !important;">
      <template v-for="(item, index) in provedata">
        <v-list-item class="qam-calc-box" :key="index">
          <template>
            <v-row class="p-2 my-2">
              <v-col
                cols="12"
                sm="4"
                lg="3"
                class="mb-2 mb-sm-0 qq-col-primary-calculater-left"
              >
                <template v-if="item.LinkLogo != null">
                  <img
                    width="250"
                    height="55"
                    class="d-block qam-provider-img"
                    v-bind:src="item.LinkLogo"
                    alt="SVG Illustration"
                  />
                </template>
                <template v-else>
                  <h5 class="qam-bold-text text-center">
                    {{ item.portalNAME }}
                  </h5>
                </template>
                <div
                  class="col-xs-12 qq-text-calculater-left-h3 qua-space-06-top"
                >
                  {{ item.PortalOrt }}
                </div>
                <div class="col-xs-12 qq-text-calculater-left-h3">
                  <a v-bind:href="item.Links" target="_blank">{{
                    item.PortalDomain_NoAff
                  }}</a>
                </div>
                <div
                  class="col-xs-12 qq-text-calculater-center-h2 text-center qua-space-06-top"
                >
                  <img
                    class="bwe-img"
                    v-bind:src="item.Sterne"
                    alt="SVG Illustration"
                  /><span class="stars-text"> {{ item.BewertungGesamt }}</span>
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="4"
                lg="6"
                class=" qq-col-primary-calculater-center"
              >
                <div class="col-xs-12 qq-text-calculater-center-h2">
                  <span
                    ><img
                      src="https://www.qam-qam.com/wp-content/uploads/2019/06/rechner-icon-feature.svg"
                      alt="SVG Illustration"
                      class="info-image"/></span
                  ><b>{{ item.PortalInfo_1 }}</b>
                </div>
                <div class="col-xs-12 qq-text-calculater-center-h2">
                  <span
                    ><img
                      src="https://www.qam-qam.com/wp-content/uploads/2019/06/rechner-icon-feature.svg"
                      alt="SVG Illustration"
                      class="info-image"/></span
                  ><b>{{ item.PortalInfo_2 }}</b>
                </div>
                <div
                  v-if="item.PortalInfo_3 != ''"
                  class="col-xs-12 qq-text-calculater-center-h2"
                >
                  <span
                    ><img
                      src="https://www.qam-qam.com/wp-content/uploads/2019/06/rechner-icon-info.svg"
                      alt="SVG Illustration"
                      class="info-image"
                    />{{ item.PortalInfo_3 }}</span
                  >
                </div>
                <div
                  v-if="item.PortalInfo_4 != ''"
                  class="col-xs-12 qq-text-calculater-center-h2"
                >
                  <span
                    ><img
                      src="https://www.qam-qam.com/wp-content/uploads/2019/06/rechner-icon-info.svg"
                      alt="SVG Illustration"
                      class="info-image"
                    />{{ item.PortalInfo_4 }}</span
                  >
                </div>
                <div class="col-xs-12 qua-space-06-top">
                  <a
                    v-bind:id="item.TriggerIDReport"
                    v-bind:href="item.LinkIntern"
                    class="btn btn-block angebotbuttonzwei"
                    role="button"
                  >
                    {{ value.ComparisonTile11 }} »
                  </a>
                </div>
              </v-col>
              <v-col
                cols="12"
                lg="3"
                sm="4"
                class="mb-2 mb-sm-0 provider-button-box qq-col-primary-calculater-right"
              >
                <div class="col-xs-12 qq-text-calculater-right-h1">
                  <b>{{ value.ComparisonTile8 }}</b>
                </div>
                <div class="col-xs-12 qq-text-calculater-right-h2">
                  <b>{{ item.Zahlungshoehe }} </b>
                </div>
                <div class="col-xs-12 qq-text-calculater-right-h3">
                  {{ textComp }}
                </div>
                <div class="col-xs-12 qua-space-06-top">
                  <a
                    v-bind:href="item.Links"
                    target="_blank"
                    v-on:click="fireAna(item.portalNAME)"
                    class="btn-sm qua-btn-primary--cta btn-block"
                    role="button"
                  >
                    {{ value.ComparisonTile12 }}
                  </a>
                </div>
              </v-col>
            </v-row>
          </template>
        </v-list-item>
      </template>
    </v-list>
  </v-card>
</template>
<script>
import axios from "axios";
export default {
  name: "OfferTable",
  props: ["value"],
  data: function() {
    return {
      isAQ: true,
      isAS: false,
      isAM: false,
      provedata: "",
      offertext: "",
      val: 0,
      textComp: "",
    };
  },
  mounted: function() {
    this.getProv();
    this.textComp = this.value.resCaseVal
      ? this.value.ComparisonTile10
      : this.value.ComparisonTile9;
  },
  methods: {
    bqb() {
      this.isAQ = true;
      this.isAS = false;
      this.isAM = false;
      this.provedata = this.provedata.slice().sort(function(a, b) {
        return a.Gesamtbewertungrang - b.Gesamtbewertungrang;
      });
    },
    btf() {
      this.isAQ = false;
      this.isAS = true;
      this.isAM = false;
      this.provedata = this.provedata.slice().sort(function(a, b) {
        return a.Dauerbewertungrang - b.Dauerbewertungrang;
      });
    },
    bvf() {
      this.isAQ = false;
      this.isAS = false;
      this.isAM = true;
      this.provedata = this.provedata.slice().sort(function(a, b) {
        return a.Hoehebewertungrang - b.Hoehebewertungrang;
      });
    },
    getProv() {
      this.provedata = "";
      let val =
        this.value.distance != null
          ? this.value.distance
          : this.value.resCaseVal;
      axios
        .post(
          "https://www.qam-qam.com/wp-content/themes/qamqam%200.1/own/func/getProviders.php",
          {
            kind: "fl",
            val: val,
            resCaseVal: this.value.resCase,
            lang: this.value.lang,
          }
        )
        .then((response) => {
          this.provedata = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    fireAna(val) {
      this.$ga.event("Rechner", val);
    },
  },
};
</script>
